import React from "react";
import { useGlobalContext } from "../../../../contexts/globalContext";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import Text from "../../../../components/Text";
import cx from "classnames";
import styles from "./DeleteCategoryModalContent.module.scss";
import { MediaCategory } from "../../../../types/Media";
import {useDeleteData} from "../../../../hooks/useDeleteData";

type DeleteCategoryModalContentProps = {
    category: MediaCategory,
    onSubmit: () => void
}

const DeleteCategoryModalContent: React.FC<DeleteCategoryModalContentProps> = (
    {
        category,
        onSubmit
    }
) => {
    const { t } = useTranslation(['settings']);
    const { closeModal, showToast } = useGlobalContext();

    const {submit} = useDeleteData('mediaCategories', category.id)

    const handleSubmit = () => {
        submit()
            .then((res) => {
                if (res.status === 200) {
                    showToast('top-right', 'success', t('categories.delete_modal.success'));
                    onSubmit();
                    closeModal();
                } else {
                    showToast('top-right', 'error', t('categories.delete_modal.error'));
                    closeModal();
                }
            })
            .catch(() => {
                showToast('top-right', 'error', t('categories.delete_modal.error'));
                closeModal();
            });
    };

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>{t('categories.delete_modal.sub_heading', {category_name: category.name})}</Text>
            <Button
                hierarchy={'primary'}
                text={t('categories.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'w-100 mx-4 my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => closeModal()}
                classes={'w-100 mx-4 my-2'}
            />
        </div>
    );
};

export default DeleteCategoryModalContent;
